import { z } from 'zod';

export const DashboardMiningTotalResponseSchema = z
  .object({
    data: z.object({
      BTC: z.object({
        yesterday: z.number(),
        historical: z.number(),
      }),
    }),
  })
  .transform((data) => data);

export type TDashboardMiningTotalResponse = z.infer<typeof DashboardMiningTotalResponseSchema>;
export type TDashboardMiningTotalData = z.infer<typeof DashboardMiningTotalResponseSchema>['data'];
